<template>
  <div class="incenters">
    <div style="width: 99.5%;overflow: scroll;">
      <Commontable colnum=7 :tableData="tableData" :headerData="headerData" height="100%" @onRowClick="onRowClick">
      </Commontable>
    </div>
    <div class="pagination">
      <Pagination type="all10" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total"></Pagination>
    </div>
  </div>
</template>
<script>
import Commontable from '../../../components/common-table.vue'
import Pagination from '../../../components/pagination.vue'
export default {
  components: {
    Commontable,
    Pagination
  },
  props: {
    tableData: {
      type: Array,
      default: Array
    },
    total: {
      type: Number,
      default: 0
    }
  },
  data: function () {
    return {
      dialogVisibles: false,
      dialogVisiblesedit: false,
      dialogVisibledel: false,
      ptype: '',
      fromdataadd: [],
      formdatadite: [],
      headerData: [{
        prop: 'id',
        label: '序号',
        columnwidth: 50
      },
      {
        prop: 'MenuCode',
        label: '菜单编码',
        columnwidth: 270
      },
      {
        prop: 'MenuName',
        label: '菜单名称',
        columnwidth: 265
      },
      ],
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    onRowClick(val) {
      this.$emit("onRowClick", val)
    },
     handleCurrentChange(pageindex) {
      this.$emit('handleCurrentChange',pageindex)
     
    },
    handleSizeChange(paegSzie) {
      this.$emit('handleSizeChange',paegSzie)

    },
  },

}
</script>

<style lang="less" scoped>
.incenters {
  height: 100%;

  .pagination {
    // display: flex;
    // justify-content: center;
    // align-items: center;
    width: 605px;
    height: 30px;
  }

  // div {
  //   margin-left: 8px;
  //   margin-right: 8px;
  //   margin-top: 5px;
  //   margin-bottom: 5px;

  // }
  .from {
    width: 100%;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    // flex-wrap: wrap;
  }

  .signingroles {
    height: 500px;
    width: 100%;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    // border: 1px solid red;

    .left {
      height: 240px;
      width: 470px;
      border: 1px solid #e6e6e6;
    }

    .right {
      height: 240px;
      width: 470px;
      border: 1px solid #e6e6e6;
      // pointer-events: none;
    }
  }
}
</style>
